<template>
    <div class="header" v-if="$store.state.user.token && $route.path != '/register' && $route.path != '/login'">
        <header-top/>
    </div>
</template>

<script>
    import HeaderTop from './HeaderTop.vue'

    export default {
        name: 'Header',
        components: {
            HeaderTop,
        }
    }
</script>

<style lang="scss" scoped>

</style>